import React from 'react';

function LoadingIndicator({ size = "large", color = "blue", fullScreen = false }) {
  const sizeClass = size === "large" ? "h-12 w-12" : size === "medium" ? "h-8 w-8" : "h-4 w-4";
  const colorClass = color === "blue" ? "border-blue-500" : color === "white" ? "border-white" : "border-gray-500";
  
  const spinner = (
    <div className={`animate-spin rounded-full ${sizeClass} border-t-2 border-b-2 ${colorClass} transition-all duration-300`}></div>
  );
  
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-80 z-50 flex justify-center items-center transition-opacity duration-300">
        {spinner}
      </div>
    );
  }
  
  return spinner;
}

export default LoadingIndicator;
